// "Connect with <booking system>" leaves the page for our begin hop and the booking system's consent page. Its own
// module so tests can mock it: jsdom cannot navigate.

/** Opens `url` in this tab as a top-level navigation; the history keeps this page, so Back returns here. */
export function openAuthorizePage(url: string): void {
    window.location.assign(url);
}
